import script from "./ModalProfiles.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalProfiles.vue?vue&type=script&setup=true&lang=js"

import "./ModalProfiles.vue?vue&type=style&index=0&id=8913e656&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8913e656"]])

export default __exports__